/* eslint-disable no-console -- Datadog cannot report its own setup errors. */
import { initializeDatadogRum } from './datadog-rum.client';

const configNode = document.getElementById('datadog-rum-config');

if (!(configNode instanceof HTMLMetaElement)) {
  // Next.js fallback documents may bypass the app layout that supplies runtime config.
  console.error(
    '[Datadog] Runtime config is missing; monitoring is skipped. A Next.js fallback document may not include the app layout.'
  );
} else if (configNode.dataset.enabled === 'true') {
  const { env, version, apiHost, defaultHost, isVisitor } = configNode.dataset;
  if (
    !env ||
    !version ||
    !apiHost ||
    !defaultHost ||
    (isVisitor !== 'true' && isVisitor !== 'false')
  ) {
    console.error('[Datadog] Enabled runtime config is incomplete; monitoring is skipped.');
  } else {
    initializeDatadogRum({
      env,
      version,
      allowedTracingUrls: [apiHost, defaultHost],
      isVisitor: isVisitor === 'true',
    });
  }
} else if (configNode.dataset.enabled !== 'false') {
  console.error('[Datadog] Runtime config has an invalid enabled flag; monitoring is skipped.');
}
